export const formatJobResult = (data: any) => {
    if (typeof data === 'string') {
        return data; // 문자열은 그대로 반환
    } else if (typeof data === 'number') {
        return data.toString(); // 숫자는 문자열로 변환
    } else if (typeof data === 'boolean') {
        return data ? 'true' : 'false'; // 불리언은 'true' 또는 'false'로 변환
    } else if (Array.isArray(data)) {
        return data.join(', '); // 배열은 쉼표로 구분된 문자열로 변환
    } else if (typeof data === 'object' && data !== null) {
        return JSON.stringify(data, null, 2); // 객체는 JSON 문자열로 변환
    } else if (data === null) {
        return 'null'; // null은 'null' 문자열로 변환
    } else if (data === undefined) {
        return 'undefined'; // undefined는 'undefined' 문자열로 변환
    } else {
        return 'undecodable data'; // 그 외 타입은 빈 문자열 반환
    }
}